module.exports = __webpack_public_path__ + "img/chuttersnap-sxhVoUrItmQ-unsplash.006d7138.jpg";